import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import backgroundImage from './assets/pngs/bg.png';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <div className="relative min-h-screen bg-[#61A0B1]">
      {/* Background div with opacity */}
      <div 
        className="absolute inset-0 bg-center bg-repeat z-0"
        style={{ 
          backgroundImage: `url(${backgroundImage})`,
          opacity: 1 
        }}
      />
      {/* Content div with full opacity */}
      <div className="relative z-10">
        <App />
      </div>
    </div>
  </React.StrictMode>
);
